import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=d6c15824&scoped=true"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"
import style0 from "./mobile.vue?vue&type=style&index=0&id=d6c15824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c15824",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/home/examsence/mobile.vue
// module id = null
// module chunks = 